import React from "react";
import { Dispatcher } from "../../flux";

module.exports = function(isbn) {
  const smallScreen = Fraction.Helpers.isSmallScreen();
  var steps = [
    {
      message: i18n.t("review-mode.tour-toc"),
      setup: () => {
        Dispatcher.emit("Extension.Launch.review-mode", isbn);
      },
      targetSelector: ".notebook-setup-sections ul:first",
      menuDirection: "bottom",
      hiddenDetailMessage: i18n.t("review-mode.tour-toc-hidden")
    },
    {
      message: i18n.t("review-mode.tour-options"),
      targetSelector: "#show-review-options",
      menuDirection: "top",
      hiddenDetailMessage: i18n.t("review-mode.tour-options-hidden")
    },
    {
      message: i18n.t("review-mode.tour-start-review"),
      targetSelector: ".start-review-button",
      teardown: () => {
        $(".start-review .submit").click();
      },
      menuDirection: "top",
      hiddenDetailMessage: i18n.t("review-mode.tour-start-review-hidden")
    },
    {
      message: i18n.t("review-mode.tour-progress"),
      targetSelector: ".review-mode .progress",
      timeout: 500,
      menuDirection: "bottom",
      hiddenDetailMessage: i18n.t("review-mode.tour-progress-hidden")
    },
    {
      message: i18n.t("review-mode.tour-next"),
      targetSelector: ".review-footer:last-child",
      menuDirection: "top",
      hiddenDetailMessage: i18n.t("review-mode.tour-next-hidden"),
      nextText: i18n.t("base.finish"),
      teardown: () => {
        Dispatcher.emit(Dispatcher.CHANGE_CHROME, "");
        Dispatcher.bindOnce(Dispatcher.BOOK_PAGE_LOAD, () => {
          setTimeout(() => {
            window.focus();
            $(".lab-learn-more").focus();
          }, 100);
        });
      }
    }
  ];

  return steps;
};
